export const GET_COLLABORATION = `query GetCollaboration($id: ID!) {
    collaboration(id: $id) {
        id
        availableSamples
        merchantSummary {
            name
            logo
            logoBgColor
        }
        campaign {
            id
            campaignProducts {
                edges {
                    node {
                        id 
                        product {
                            id 
                            externalProductId 
                            name
                            platform
                            variants(availableAsSample: true) {
                                id
                                name
                                externalImageUrls
                            }
                        }
                    }
                }
            }
        }
    }
}`;
